// components/AdditionalResourcesAccordion.js
import { useState } from 'react';

export default function AdditionalResourcesAccordion({ resources, className = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  // Don't render if no resources
  if (!resources || resources.length === 0) {
    return null;
  }

  return (
    <div className={`border border-secondary-200 dark:border-secondary-700 rounded-lg overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-secondary-50 dark:bg-secondary-800 hover:bg-secondary-100 dark:hover:bg-secondary-750 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="font-semibold text-secondary-900 dark:text-white flex items-center gap-2">
          <svg className="w-5 h-5 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          משאבים נוספים
        </span>
        <svg
          className={`w-5 h-5 text-secondary-600 dark:text-secondary-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="p-4 bg-white dark:bg-secondary-900 border-t border-secondary-200 dark:border-secondary-700">
          <div className="space-y-4">
            {resources.map((resource, idx) => (
              <div key={idx} className="border-b border-secondary-200 dark:border-secondary-700 pb-4 last:border-0">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <h4 className="font-semibold text-secondary-900 dark:text-white mb-1">
                      {resource.title}
                    </h4>
                    {resource.author && (
                      <p className="text-sm text-secondary-600 dark:text-secondary-400 mb-2">
                        מחבר: {resource.author}
                      </p>
                    )}
                    <p className="text-sm text-secondary-500 dark:text-secondary-500">
                      {resource.resource_type_label}
                    </p>
                  </div>
                  <a
                    href={resource.file_url || resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors whitespace-nowrap"
                  >
                    מעבר למשאב
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

